import { Component, inject } from '@angular/core';
import { cacTableIdCol, PushNotificationApiService } from '@core';
import { CacTableComponent, formBuilder, table } from '@controladad/ng-base';
import { formControl, Validators } from '@al00x/forms';
import { switchMap } from 'rxjs';

@Component({
  selector: 'lib-push-notification',
  imports: [CacTableComponent],
  templateUrl: './push-notification.component.html',
  styleUrl: './push-notification.component.scss',
})
export class PushNotificationComponent {
  private readonly pushNotificationApi = inject(PushNotificationApiService);

  table = table({
    itemsFn: this.pushNotificationApi.getAdapter(),
    view: { itemName: 'Notification' },
    columns: {
      id: { label: 'FilterId', sortable: 'Id', filterable: 'NotificationId' },
      title: { label: 'Title' },
      body: { label: 'Body' },
      creatorId: { label: 'Admin ID', sortable: true },
      createdAt: { label: 'Created At', type: 'datetime', sortable: true },
    },

    events: { add: () => this.dialog() },
  });

  private dialog() {
    return dialog$
      .input({
        title: 'Send Notification',
        formBuilder: formBuilder({
          cols: 1,
          inputs: {
            title: { control: formControl<string>(undefined, Validators.required), label: 'Title' },
            body: { control: formControl<string>(undefined, Validators.required), label: 'Body', type: 'textarea' },
          },
        }),
      })
      .afterSubmit()
      .pipe(switchMap((value) => this.pushNotificationApi.create(value)));
  }
}
